const actions = {
    REGISTER_REQUEST: 'REGISTER_REQUEST',
    REGISTER_SUCCESS: 'REGISTER_SUCCESS',
    REGISTER_ERROR: 'REGISTER_ERROR',
    ACTIVATE_REQUEST: 'ACTIVATE_REQUEST',
    ACTIVATE_SUCCESS: 'ACTIVATE_SUCCESS',
    ACTIVATE_ERROR: 'ACTIVATE_ERROR',
    SEND_ACTIVATION_CODE_REQUEST: 'SEND_ACTIVATION_CODE_REQUEST',
    SEND_ACTIVATION_CODE_SUCCESS: 'SEND_ACTIVATION_CODE_SUCCESS',
    SEND_ACTIVATION_CODE_ERROR: 'SEND_ACTIVATION_CODE_ERROR',
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_ERROR: 'LOGIN_ERROR',
    REAUTHENTICATE_REQUEST: 'REAUTHENTICATE_REQUEST',
    REAUTHENTICATE_SUCCESS: 'REAUTHENTICATE_SUCCESS',
    REAUTHENTICATE_ERROR: 'REAUTHENTICATE_ERROR',
    RESET_TOKEN_REQUEST: 'RESET_TOKEN_REQUEST',
    RESET_TOKEN_SUCCESS: 'RESET_TOKEN_SUCCESS',
    RESET_TOKEN_ERROR: 'RESET_TOKEN_ERROR',
    RESET_PASSWORD_REQUEST: 'RESET_PASSWORD_REQUEST',
    RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
    RESET_PASSWORD_ERROR: 'RESET_PASSWORD_ERROR',
    RESET_PASSWORD_HIDE: 'RESET_PASSWORD_HIDE',
    CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',
    CHECK_AUTHORIZATION_SUCCESS: 'CHECK_AUTHORIZATION_SUCCESS',
    VALIDATE_SESSION_REQUEST: 'VALIDATE_SESSION_REQUEST',
    VALIDATE_SESSION_SUCCESS: 'VALIDATE_SESSION_SUCCESS',
    VALIDATE_SESSION_ERROR: 'VALIDATE_SESSION_ERROR',
    READ_INVITE_REQUEST: 'READ_INVITE_REQUEST',
    READ_INVITE_SUCCESS: 'READ_INVITE_SUCCESS',
    READ_INVITE_ERROR: 'READ_INVITE_ERROR',
    READ_ACCOUNT_SETS_REQUEST: 'READ_ACCOUNT_SETS_REQUEST',
    READ_ACCOUNT_SETS_SUCCESS: 'READ_ACCOUNT_SETS_SUCCESS',
    READ_ACCOUNT_SETS_ERROR: 'READ_ACCOUNT_SETS_ERROR',
    ACCEPT_INVITE_REQUEST: 'ACCEPT_INVITE_REQUEST',
    ACCEPT_INVITE_SUCCESS: 'ACCEPT_INVITE_SUCCESS',
    ACCEPT_INVITE_ERROR: 'ACCEPT_INVITE_ERROR',
    BOOT_INTERCOM_REQUEST: 'BOOT_INTERCOM_REQUEST',
    BOOT_INTERCOM_SUCCESS: 'BOOT_INTERCOM_SUCCESS',
    BOOT_INTERCOM_ERROR: 'BOOT_INTERCOM_ERROR',
    OPEN_ACCESS_DENIED_MODAL: 'OPEN_ACCESS_DENIED_MODAL',
    CLOSE_ACCESS_DENIED_MODAL: 'CLOSE_ACCESS_DENIED_MODAL',
    SET_SESSION_READY: 'SET_SESSION_READY',
    CHANGE_SESSION_LOCALE: 'CHANGE_SESSION_LOCALE',
    LOGOUT: 'LOGOUT',

    register: payload => ({
        type: actions.REGISTER_REQUEST,
        payload,
    }),
    activate: request => ({
        type: actions.ACTIVATE_REQUEST,
        request,
    }),
    sendActivationCode: request => ({
        type: actions.SEND_ACTIVATION_CODE_REQUEST,
        request,
    }),
    login: payload => ({
        type: actions.LOGIN_REQUEST,
        payload, // { subdomain, email, password, remember }
    }),
    reauthenticate: payload => ({
        type: actions.REAUTHENTICATE_REQUEST,
        payload,
    }),
    resetToken: payload => ({
        type: actions.RESET_TOKEN_REQUEST,
        payload,
    }),
    resetPassword: payload => ({
        type: actions.RESET_PASSWORD_REQUEST,
        payload,
    }),
    resetPasswordHide: () => ({
        type: actions.RESET_PASSWORD_HIDE,
    }),
    checkAuthorization: () => ({
        type: actions.CHECK_AUTHORIZATION,
    }),
    validateSession: () => ({
        type: actions.VALIDATE_SESSION_REQUEST,
    }),
    readInvite: (id, secret) => ({
        type: actions.READ_INVITE_REQUEST,
        payload: {
            id,
            secret,
        },
    }),
    acceptInvite: payload => ({
        type: actions.ACCEPT_INVITE_REQUEST,
        payload,
    }),
    readAccountSets: () => ({
        type: actions.READ_ACCOUNT_SETS_REQUEST,
    }),
    logout: () => ({
        type: actions.LOGOUT,
    }),
    bootIntercom: payload => ({
        type: actions.BOOT_INTERCOM_REQUEST,
        payload,
    }),
    openAccessDeniedModal: feature => ({
        type: actions.OPEN_ACCESS_DENIED_MODAL,
        feature,
    }),
    closeAccessDeniedModal: () => ({
        type: actions.CLOSE_ACCESS_DENIED_MODAL,
    }),
    updateCurrentRouteAccess: () => ({
        type: actions.UPDATE_CURRENT_ROUTE_ACCESS,
    }),
};
export default actions;
